import { AuxiliumComponent } from "../auxilium-component";

export class List extends AuxiliumComponent {
	constructor() {
		super();

		this.ordered = this.hasAttribute("ordered");
		this.flush = this.hasAttribute("flush");
		this.gap = this.getAttribute("gap");
		this.clickable = this.hasAttribute("clickable");
		this.buttonPadding = this.getAttribute("button-padding");
	}

	parsedCallback() {
		const list = document.createElementWithContents(this.ordered ? "ol" : "ul", [...this.querySelectorAll(":scope > chip-listitem")]
			.map(x => document.createElementWithContents("li", x)));

		if (this.flush) { list.classList.add("list-flush"); }
		if (this.gap) { list.classList.add(`spaced-list--${this.gap}`); }

		this.appendChild(list);
	}
}